import React from 'react';
import { AlignmentTypes } from '@insurancemenu/imenu-components-lib/dist/types';
import { getUniqueProductLinesFromArray } from '@insurancemenu/imenu-components-lib/dist/utils/ProductLinesHelper';
import { InCellDivisionBlockProps } from 'components/common/general/InCellDivisionBlock';
import { DashboardEnrollmentPresenter } from 'types/enrollmentService';
import { InCellDivisionWrapper } from '..';
import { ShortProductLinesTitleStyled, TooltipContainerStyled, TooltipStyled } from './styles';

export interface ProductLineCellContentProps {
  isGroupWithMultiplePeriods: boolean;
  id: string;
  cellProps?: InCellDivisionBlockProps;
  enrollmentPeriod: DashboardEnrollmentPresenter;
}

const ProductLinCellContent = ({
  isGroupWithMultiplePeriods,
  cellProps,
  enrollmentPeriod,
  id,
}: ProductLineCellContentProps): JSX.Element => {
  const combinedProductLines = getUniqueProductLinesFromArray(enrollmentPeriod.productLineIds);

  const productLinesList = isGroupWithMultiplePeriods ? (
    <TooltipContainerStyled>
      {combinedProductLines ? (
        <TooltipStyled alignment={AlignmentTypes.RIGHT_CENTER} label={combinedProductLines}>
          <ShortProductLinesTitleStyled>{combinedProductLines}</ShortProductLinesTitleStyled>
        </TooltipStyled>
      ) : null}
    </TooltipContainerStyled>
  ) : (
    <span>{combinedProductLines}</span>
  );

  return (
    <InCellDivisionWrapper
      id={id}
      inCellProps={{
        ...cellProps,
      }}
      withBorder={cellProps?.withBorder || true}
      maxWidth={cellProps?.maxWidth || '90%'}
    >
      {productLinesList}
    </InCellDivisionWrapper>
  );
};

export default ProductLinCellContent;
